<template>
  <a-card :bordered="false">
    <search-page-view
      ref="table"
      rowKey="orderNo"
      :itemNames="['search_proId','search_proName','create_button',]"
      :columns="columns"
      :queryParams="queryParams"
      :requestPromise="loadPromise"
    >
      <a-form-item slot="search_proId" label="关联销售订单号" v-bind="formItemLayout">
        <a-input v-model="queryParams.orderNo" placeholder="请输入"></a-input>
      </a-form-item>
      <a-form-item slot="search_proName" label="绿云PMS订单号" v-bind="formItemLayout">
        <a-input v-model="queryParams.supplerOrderNo" placeholder="请输入"></a-input>
      </a-form-item>
      <div slot="contactSlot" slot-scope="rowItem">
        <div>{{ rowItem.record.contactName }}</div>
        <div>{{ rowItem.record.phone }}</div>
      </div>
    </search-page-view>
  </a-card>
</template>

<script>
export default {
  name: 'DirectOrdersList',
  data() {
    return {
      queryParams: {
        orderType: 21
      },
      loadPromise: params => this.getListPromise(params),
      columns: [
        {
          title: '绿云PMS订单号',
          dataIndex: 'supplerOrderNo'
        },
        {
          title: '关联销售订单号',
          dataIndex: 'orderNo'
        },
        {
          title: '产品名称',
          dataIndex: 'proName'
        },
        {
          title: '套餐',
          dataIndex: 'optionName'
        },
        {
          title: '下单用户',
          dataIndex: 'contactName',
          scopedSlots: { customRender: 'contactSlot' }
        },
        {
          title: '订单来源',
          dataIndex: 'sourceStr'
        },
        {
          title: '订单状态',
          dataIndex: 'statusStr'
        },
        {
          title: '供应商名称',
          dataIndex: 'accountName'
        },
        {
          title: '下单时间',
          dataIndex: 'createTime'
        }
      ],
      formItemLayout: {
        labelCol: {
          xxl: { span: 7 },
          xl: { span: 7 },
          lg: { span: 8 },
          sm: { span: 9 },
          md: { span: 10 },
          xs: { span: 10 }
        },
        wrapperCol: {
          xxl: { span: 17 },//≥1600px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xl: { span: 17 },//≥1200px 响应式栅格，可为栅格数或一个包含其他属性的对象
          lg: { span: 16 },//≥992px 响应式栅格，可为栅格数或一个包含其他属性的对象
          sm: { span: 15 },//≥768px 响应式栅格，可为栅格数或一个包含其他属性的对象
          md: { span: 14 },//≥576px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xs: { span: 14 }//xs	<576px 响应式栅格，可为栅格数或一个包含其他属性的对象
        }
      }

    }
  },
  mounted() {
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'PMSProductList', title: '同步商品' },
      { name: 'PMSDirectOrdersList', title: '订单直连' },
      { name: 'PMSAssociatedAccount', title: '关联账号' }
    ])
  },
  methods: {
    // 获取表格数据接口
    getListPromise(params) {
      return this.getHttpServices().getOrderService().post('direct/getDirectOrderPage', params)
    }
  }
}
</script>

<style scoped>

</style>